import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';
import {SmAppUpdateProgressComponent} from './sm-app-update-progress.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
  ],
  declarations: [SmAppUpdateProgressComponent],
  exports: [SmAppUpdateProgressComponent],
})
export class SmAppUpdateProgressModule {}
